import {useState} from 'react';
import Lottie from 'react-lottie-player'
import verifyAnimation from '../animations/verify.json';
import api from '../api';

function Verify({user, setUser}) {
	const [verificationCode, setVerificationCode] = useState('');
	const [error, setError] = useState(null);

	const checkCode = (e) => {
		e.preventDefault();
		setError(null);
		if(verificationCode.length !== 6){
			setError('The verification code should be 6 digits long');
			return;
		}
		api.checkVerificationCode(user.token,verificationCode)
		.then(({data}) => {
			if(data.status === 'SUCCESS'){
				localStorage.setItem('user', JSON.stringify({
					token: user.token,
					user: data.data
				}));
				window.location.reload();
			}else{
				setError('Invalid verification code');
			}
		})
		.catch((e) => {
			setError('An unexpected error occured. Please try again later!');
		})
	}
	return (
		<div className="page">
			<div className="card">
				<div className="text__center">
					<Lottie
						loop
						animationData={verifyAnimation}
						play
						style={{ width: 250, height: 250, margin: 'auto' }}
					/>
					<h3>Verify your email adress</h3>
					<div>A verification code has been sent to your email. Insert it below and enjoy our features.</div>
					<form className="mtop--20" style={{width: '320px', margin: 'auto'}} onSubmit={checkCode}>
						<div className="input__wrap mtop--10">
							<input type="text" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} placeholder="# # # # # #" className="verification__input" />
						</div>
						{error && <div className="text__danger">{error}</div>}
						<button className="btn btn__primary btn__100 mtop--10" disabled={verificationCode.length !== 6}>Verify</button>
					</form>
				</div>
			</div>
		</div>
	)
}

export default Verify